module.exports = __webpack_public_path__ + "static/img/MenuFont.910424b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/images/MenuFont.png
// module id = 38
// module chunks = 2